/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForOkta extends models.ServiceAccountNativeDetailsBaseForSaasOtherServices {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForOkta");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForOkta.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForOkta>): ServiceAccountNativeDetailsForOkta {
        let obj = Object.assign(new ServiceAccountNativeDetailsForOkta(), model);
        ServiceAccountNativeDetailsForOkta.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForOkta>): ServiceAccountNativeDetailsForOkta {
        if (!model) return null;
        return ServiceAccountNativeDetailsForOkta.newInstance(<ServiceAccountNativeDetailsForOkta> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForOkta) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForOkta.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForOkta): boolean {
        if (models.ServiceAccountNativeDetailsBaseForSaasOtherServices.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForOkta.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
